import usePush from './usePush';
import usePushLocationSearch from './usePushLocationSearch';

const PATH = '/signUp';
const PATH_FORM = '/signUpForm';

const usePushSignUp = (options = { form: false, keepQueries: false }) => {
  const pushPath = usePush();
  const pushPathLocationSearch = usePushLocationSearch();

  const pushSignUp = () => {
    const path = options.form ? PATH_FORM : PATH;
    if (options.keepQueries) {
      // Push to sign-up page with URL queries
      pushPathLocationSearch(path);
      return;
    }
    // Push to sign-up page without URL queries
    pushPath(path);
  };
  return pushSignUp;
};

export default usePushSignUp;
